import * as React from "react";
import axios from 'axios';
import useSnackbarAlert from '../../../utils/snackbarHandlers';
import { AdvertisementsListProps } from ".";

interface AdsListGetterChildren {
  (data: AdvertisementsListProps): React.ReactNode;
}

interface AdsListGetterProps {
  children: AdsListGetterChildren;
}

const AdsListGetter: React.FC<AdsListGetterProps> = ({ children }) => {
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
  const [loading, setLoading] = React.useState<boolean>(false);
  const [adsData, setAdsData] = React.useState<Array<any>>([]);
  const [totalCount, setTotalCount] = React.useState<number>(0);
  const { showErrorMessage } = useSnackbarAlert();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [refreshTable, setRefreshTable] = React.useState<number>(0);
  const uId = JSON.parse(localStorage.getItem('UserData') || "");

  React.useEffect(() => {
    setLoading(true);
    const payload = {
      pageNumber: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      adLocation: ["HEADER", "FOOTER"],
      userId: uId ? uId?.uId : "",
    }
    axios.post(`${apiBaseURL}/api/advertisement/getAdvertisementDetails`, payload)
      .then((res: any) => {
        setAdsData(res?.data?.advertisements)
        setTotalCount(res?.data?.totalRecords)
      })
      .catch((error: Error) => showErrorMessage(error))
      .finally(() => setLoading(false));
  }, [paginationModel, refreshTable]);

  return (
    <React.Fragment>
      {children({
        adsData,
        totalCount,
        loading,
        paginationModel,
        setPaginationModel,
        setRefreshTable,
      })}
    </React.Fragment>
  );
};

export default AdsListGetter;
